import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export const CHECKOUT_URL = 'https://swimming-coach-ready.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  const classes = `
    block w-full text-center cursor-pointer
    px-4 py-4 sm:py-5
    font-button font-black text-base sm:text-xl uppercase tracking-wide
    rounded-md
    bg-brand-orange text-white
    hover:bg-[#E65C00] hover:scale-[1.02] 
    transition-all duration-200
    border-b-4 border-[#CC5200] active:border-b-0 active:translate-y-1
    shadow-[0_4px_14px_0_rgba(255,102,0,0.39)] hover:shadow-[0_6px_20px_rgba(255,102,0,0.5)]
    ${className}
  `;
  return <a href={CHECKOUT_URL} className={classes} data-id="element-36">
      {children}
    </a>;
}